import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_PATHS } from '../constants/api-paths';
import { jsonHttpHeaders } from '../constants/http-headers';
import { Contact } from '../models/contact.model';

/**
 * Client HTTP des contacts / entrées en relation ({@code /contacts}).
 */
@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private readonly http: HttpClient) {}

  /** Liste tous les contacts. */
  findAll(): Observable<Contact[]> {
    return this.http.get<Contact[]>(
      `${environment.apiUrl}${API_PATHS.contacts}`
    );
  }

  /** Détail d'un contact. */
  findById(id: string): Observable<Contact> {
    return this.http.get<Contact>(
      `${environment.apiUrl}${API_PATHS.contact(id)}`
    );
  }

  /** Crée un contact. */
  create(contact: Contact): Observable<Contact> {
    return this.http.post<Contact>(
      `${environment.apiUrl}${API_PATHS.contacts}`,
      contact,
      { headers: jsonHttpHeaders() }
    );
  }

  /** Met à jour un contact existant. */
  update(contact: Contact): Observable<Contact> {
    return this.http.put<Contact>(
      `${environment.apiUrl}${API_PATHS.contact(contact.idContactDto ?? '')}`,
      contact,
      { headers: jsonHttpHeaders() }
    );
  }

  /** Supprime un contact. */
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiUrl}${API_PATHS.contact(id)}`
    );
  }

  /** Refuse un contact avec motif ({@code POST .../refuser}). */
  refuser(id: string, motifRefusDto: string): Observable<Contact> {
    return this.http.post<Contact>(
      `${environment.apiUrl}${API_PATHS.contactRefuser(id)}`,
      { motifRefusDto },
      { headers: jsonHttpHeaders() }
    );
  }

  /** Rouvre un contact refusé ({@code POST .../reouvrir}). */
  reouvrir(id: string): Observable<Contact> {
    return this.http.post<Contact>(
      `${environment.apiUrl}${API_PATHS.contactReouvrir(id)}`,
      {}
    );
  }
}
